import React from 'react'
import ReportAbuse from './reportAbuse/ReportAbuse'
import Accordian from 'src/components/shared/modules/accordian/Accordian'
import ReportNow from './reportNow/ReportNow'
import { AccordianContent } from 'src/types/components/shared/atom'
import { reportReportAbuse } from 'src/types/store'
import { getCookie } from 'cookies-next'
import useStyles from './Styles';
interface Props {
  zenMode: boolean
  content: {
    reportAbuse: reportReportAbuse
    accordianContent: AccordianContent
  }
}
function Report({ zenMode, content }: Props) {
  const lang = getCookie('lang')
  const {classes} = useStyles()
  return (
    <div>
      <ReportAbuse content={content.reportAbuse} zenMode={zenMode} />
      <Accordian
        accordianData={content.accordianContent.accordianData}
        gradient={true}
      />
      <div className={classes.iframeContainer} id="report-now">
        <ReportNow
          src={
            lang === 'En'
              ? 'https://form.typeform.com/to/EEGWoceU?typeform-embed-id=6988738856264229&amp;typeform-embed=embed-widget&amp;typeform-source=ditchthelabel.org&amp;typeform-medium=snippet&amp;typeform-medium-version=next'
              : 'https://ditch-thelabel.typeform.com/to/pXlYFUpm?typeform-source=www.google.com'
          }
        />
      </div>
    </div>
  )
}

export default Report
